import Box from "@mui/material/Box";
import React from "react";

interface LastUpdatedAtProps {
  updatedAt: Date;
}

export function LastUpdatedAt({ updatedAt }: LastUpdatedAtProps) {
  const now = new Date();

  const startOfDay = (d: Date) =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate());

  const msPerDay = 1000 * 60 * 60 * 24;
  const daysDiff = Math.floor(
    (startOfDay(now).getTime() - startOfDay(updatedAt).getTime()) / msPerDay,
  );

  let text: string;
  if (daysDiff <= 0) {
    text = "Last updated today";
  } else if (daysDiff === 1) {
    text = "Last updated yesterday";
  } else {
    text = `Last updated ${daysDiff} days ago`;
  }

  return <Box className="text-sm italic font-light">{text}</Box>;
}
